import React from 'react'
import styles from './nav-link.styles'
import injectSheet from 'react-jss'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'

const NavLink = ({ classes, children, path, location }) => (
  <li
    className={classNames(classes.link, {
      [classes.activeLink]: '/' + location.pathname.split('/')[1] === path
    })}>
    <Link className={classes.link} to={path}>
      {children}
    </Link>
  </li>
)

export default withRouter(injectSheet(styles)(NavLink))
